import React, { useState } from 'react';
import EcoCommunity from './EcoCommunity/EcoCommunity';
import EcoProducts from './EcoProducts/EcoProducts';
import './EcoAllianceSustainability.scss';
import EcoOurJourney from './EcoOurJourney/EcoOurJourney';

const EcoAllianceSustainability = () => {

  const [selectedTab, setSelectedTab] = useState(1);

  const openLink = () => window.open(`https://www.noissue.co/blog/eco-alliance/`, '_blank', 'noopener');

  return (
    <div className="noissue__eco-alliance__sustainability">
      <button className="noissue__eco-alliance__sustainability__see-more-high" onClick={openLink} id="sustainability-for-you-and-us">
        See More Highlights
      </button>
      <div className="noissue__eco-alliance__sustainability__container">
        <div className="noissue__eco-alliance__sustainability__container__heading">
          Sustainability For You and Us
        </div>
        <div className="noissue__eco-alliance__sustainability__container__tabs">
          <span onClick={() => setSelectedTab(1)} role="presentation" className={`${selectedTab === 1 && 'selected'}`}>Community</span>
          <span onClick={() => setSelectedTab(2)} role="presentation" className={`${selectedTab === 2 && 'selected'}`}>Our Products</span>
          <span onClick={() => setSelectedTab(3)} role="presentation" className={`${selectedTab === 3 && 'selected'}`}>Our Journey</span>
        </div>
        {
          selectedTab === 1 && 
          <EcoCommunity />
        }
        {
          selectedTab === 2 && 
          <EcoProducts />
        }
        {
          selectedTab === 3 && 
          <EcoOurJourney />
        }
      </div>
      <div id="sport-your-support"></div>
    </div>
  )
}

export default EcoAllianceSustainability;